import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatChipsModule} from '@angular/material/chips';
import {MatOptionModule} from '@angular/material/core';
import {MatDialogModule} from '@angular/material/dialog';
import {MatSelectModule} from '@angular/material/select';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatCardModule} from '@angular/material/card';

import {RouterModule} from '@angular/router';

import {TranslateModule} from '@ngx-translate/core';

import {DragDropModule} from '@angular/cdk/drag-drop';
// import {DateTimePickerStaticModule} from '../tinea-components/dateTime-picker/dateTime-picker.module';
// import {DisplayErrorsMessageModule} from '../tinea-components/display-errors-message/display-errors-message.module';
// import {FileDownloadModule} from '../tinea-components/file-download/file-download.module';
// import {FileUploadModule} from '../tinea-components/file-upload/file-upload.module';
// import {LoadingModule} from '../tinea-components/loading/loading.module';
// import {PagingModule} from '../tinea-components/paging/paging.module';
// import {TableModule} from '../tinea-components/table/table.module';
//import {TogglePasswordModule} from './directives/toggle-password.module';
// import {LetModule} from '@rx-angular/template/let';
import {MatMenuModule} from '@angular/material/menu';
import {AuthenCubeJsService} from '../tinea-components/okta/auth/services/authen-cubejs.service';

// const cubejsClientFactory = (authService: AuthenCubeJsService) => {
//     return new CubejsClient(authService.config$);
// };

@NgModule({
    declarations: [
        // JumpingDotsComponent,
        // ModalStationsComponent,
        // QueryRendererComponent,
        // ModalNewExportComponent,
        // CollapseComponent,
        // ReadWriteDirective,
        // NumberFormatPipe,
        // PlanningDiffusionListComponent,
        // ContentTabComponent,
        // ContentTabListComponent,
        // ChangeRouterlinkDirective,
        // PopupBtnActionComponent,
    ],
    imports: [
        CommonModule,
        MatAutocompleteModule,
        MatOptionModule,
        MatTableModule,
        MatSlideToggleModule,
        MatChipsModule,
        RouterModule,
        // LoadingModule,
        TranslateModule,
        FormsModule,
        DragDropModule,
        MatDialogModule,
        ReactiveFormsModule,
        // DateTimePickerStaticModule,
        // DisplayErrorsMessageModule,
        MatTooltipModule,
        // TableModule,
        // PagingModule,
        MatSelectModule,
        // BtnActionModule,
        // SearchModule,
        MatCardModule,
        // FileUploadModule,
        // FileDownloadModule,
        // TogglePasswordModule,
        // LetModule,
        MatMenuModule,
    ],
    exports: [
      // JumpingDotsComponent,
      // ErrorComponent,
      // QueryRendererComponent,
      // CollapseComponent,
      // ReadWriteDirective,
      // NumberFormatPipe,
      // PlanningDiffusionListComponent,
      // ChangeRouterlinkDirective,
      // PopupBtnActionComponent,
      // BtnActionComponent,
      // BtnActionListComponent,
      // SearchComponent,
    ],
    // providers: [
    //     AuthenCubeJsService,
    //     {
    //         provide: CubejsClient,
    //         useFactory: cubejsClientFactory,
    //         deps: [AuthenCubeJsService],
    //     },
    // ],
})
export class SharedModule {
}
